import CRUD from './crud'

export default new CRUD('tournament-participant-votes', 'superior-judge')
